<template>
  <div class="normacsinfo-wrapper">
    <div class="normacsinfo__title"> <!-- class="frontpage__title frontpage__title_ncsinfo"> -->
      NormaCS.info
    </div>
    
    <div class="normacsinfo">
      <p v-if="error">
        {{`Ошибка: ${error.message}`}}
      </p>
      
      <template v-if="info">
        <div
          v-for="(section, key) in sections"
          :key="key"
          class="normacsinfo__block"
        >
          <img class="normacsinfo__block-icon" :src="section.icon" alt="" />
          <a
            :is="hasInternet ? 'a' : 'span'"
            class="normacsinfo__block-title"
            :href="section.url"
            target="_blank"
          >
            {{ section.title }}
          </a>
          <div v-for="(item, i) in info[key]" :key="i">
            <time class="normacsinfo__block-date">
              {{ item.time }}, {{ item.date | formatDate }}
            </time>
            <router-link
              class="normacsinfo__block-body"
              v-bind="makeItemLinkProps(key, item)"
              v-text="item.title"
            />
          </div>
        </div>
      </template>

      <loader-dots v-if="!error && !info" />
    </div>
  </div>
</template>

<script>
import apiApp from '@src/api/app';
import { ROUTE_ARTICLE } from '@src/routes';
import LoaderDots from '@@/shared/loaders/LoaderDots';

const makeSectionIconUrl = iconFile => {
  return `${__BASE_URL__}img/icons/${iconFile}`;
};

export default {
  components: {
    LoaderDots
  },

  data: () => ({
    info: null,
    error: null
  }),

  computed: {
    /** @returns {AppConfig} */
    config() {
      return this.$store.state.config;
    },

    hasInternet() {
      return this.$store.state.hasInternet;
    },

    sections() {
      /** @type {AppConfig} */
      let config = this.config;

      return {
        projects: {
          title: 'Проекты',
          url: config.normacsProjectsUrl,
          icon: makeSectionIconUrl('normacs-projects.svg')
        },
        discussions: {
          title: 'Обсуждения',
          url: config.normacsDiscussionsUrl,
          icon: makeSectionIconUrl('normacs-discussions.svg')
        },
        ntds: {
          title: 'НТД',
          url: config.normacsNtdsUrl,
          icon: makeSectionIconUrl('normacs-ntds.svg')
        },
        news: {
          title: 'Новости',
          url: config.normacsNewsUrl,
          icon: makeSectionIconUrl('normacs-news.svg')
        }
      };
    }
  },

  created() {
    apiApp.getNormacsInfo(1).then(
      info => {
        this.info = info;
      },
      error => {
        this.error = error;
      }
    );
  },

  methods: {
    /**
     * @param {string} sectionId
     * @param {ApiNormacsInfoItem} item
     * @returns {Object}
     */
    makeItemLinkProps(sectionId, item) {
      if (this.hasInternet) {
        /**
         * Заменяем <router-link> на <a>, так как он искажает внешние URL.
         * @see {@link https://github.com/vuejs/vue-router/issues/1280}
         */
        return {
          is: 'a',
          href: item.url,
          target: '_blank',
          rel: 'noopener'
        };
      }

      return {
        to: this.makeArticleRoute(sectionId, item.id)
      };
    },

    /**
     * @param {string} sectionId
     * @param {string} itemId
     * @returns {Object}
     */
    makeArticleRoute(sectionId, itemId) {
      return {
        name: ROUTE_ARTICLE,
        params: {
          section: sectionId,
          id: itemId
        }
      };
    }
  }
};
</script>

<style lang="css" src="./normacs-info.css" />
